// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.alicebob",
    name: "Alicebob Wallet",
    homepage: "https://alicebob.com/",
    image_id: "15be8ddd-0bef-4948-56d1-6101347a6b00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/alicebob-crypto-btc-wallet/id6467197622",
        android: "https://play.google.com/store/apps/details?id=com.crypto.ab.wallet.app",
        mac: "https://apps.apple.com/us/app/alicebob-crypto-btc-wallet/id6467197622",
        windows: null,
        linux: null,
        chrome: "https://chromewebstore.google.com/detail/alicebob-wallet/mjmpkbeecljmaoojijflpfpmpdhnpabd",
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "crypto.ab.wallet://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map